import { Skeleton } from '@mui/material';

export const Placeholder = ({ size }: { size: number }) => {
  const loadingItems = Array.from({ length: size }, (_, index) => index);

  return (
    <div className="w-full flex flex-wrap">
      {loadingItems.map((item) => (
        <div
          key={item}
          className="bg-white mb:basis-1/2 xl:basis-1/4 basis-full flex animate-pulse p-4"
        >
          <div className="flex flex-col w-full h-full items-center justify-center">
            <div className="bg-gray-200 rounded-md h-24 w-full" />
            <div className="h-22 w-full flex flex-col gap-2 p-3">
              <Skeleton width="90%" />
              <Skeleton width="100%" />
              <Skeleton width="30%" />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
